
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiAziendeGrid extends Serenity.EntityGrid<ProdottiAziendeRow, any> {
        protected getColumnsKey() { return ProdottiAziendeColumns.columnsKey; }
        protected getDialogType() { return ProdottiAziendeDialog; }
        protected getIdProperty() { return ProdottiAziendeRow.idProperty; }
        protected getInsertPermission() { return ProdottiAziendeRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiAziendeRow.localTextPrefix; }
        protected getService() { return ProdottiAziendeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}